// hooks/useScrollToSection.ts
import { useEffect, RefObject } from "react";
import { useLocation } from "react-router-dom";

export const useScrollToSection = (
  ref: RefObject<HTMLElement>,
  sectionId: string
) => {
  const { state } = useLocation();

  const scrollToSection = () => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    if (state?.scrollTo === sectionId && ref.current) {
      scrollToSection();
    }
  }, [state, sectionId]);

  return scrollToSection;
};


export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return null;
}